<div class="dropparit-container" [class.lemon-lang-fi]="(kieliObservable | async) === 'fi'" [class.lemon-lang-en]="(kieliObservable | async) === 'en'">
  <div class="dropparit placeholder-isoilla">
    @if (naytaLaskunTyyppiObservable | async) {
      <div class="ekadroppari">
        <mat-form-field class="no-underline valkoinen pyoristettu-potko-select">
          <mat-label>{{ 'lasku.tyyppi' | translate | async }}</mat-label>
          <mat-select [formField]="parent.ennakkolasku">
            @for (valinta of onkoEnnakkoLasku | async; track valinta) {
              <mat-option [value]="valinta">
                {{ 'laskuntyyppi.' + (valinta ? 'ennakko' : 'tav') | translate | async }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    <div [class]="((naytaLaskunTyyppiObservable | async) ? 'tokadroppari' : 'ekadroppari') + ' pitkadroppari'">
      <mat-form-field class="no-underline valkoinen pyoristettu-potko-select">
        <mat-label>{{ 'lasku.myyntilaji' | translate | async }}</mat-label>
        <mat-select [compareWith]="vertaaTyyppia" [formField]="parent.tyyppi">
          @for (tyyppi of tyypitObservable | async; track tyyppi) {
            <mat-option [value]="tyyppi">
              {{ 'myynnin-laji.' + tyyppi.avain | translate | async }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="kolmasdroppari">
      <mat-form-field class="no-underline valkoinen pyoristettu-potko-select">
        <mat-label>{{ 'lasku.valuutta' | translate | async }}</mat-label>
        <mat-select [formField]="parent.valuutta">
          @for (valuutta of valuutatObservable | async; track valuutta) {
            <mat-option [value]="valuutta.koodi"> {{ valuutta.koodi }} ({{ 'valuutta.' + valuutta.koodi | translate | async }}) </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="neljasdroppari">
      <mat-form-field class="no-underline valkoinen pyoristettu-potko-select">
        <mat-label>{{ 'lasku.kieli' | translate | async }}</mat-label>
        <mat-select [formField]="parent.kieli">
          @for (kieli of kielet | async; track kieli) {
            <mat-option [value]="kieli">
              {{ 'kieli.' + kieli | translate | async }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
